<template>
    <div>
        <!--    <span class="iconfont icon-back"></span>-->
        <!--    <div style="font-size: 2rem">asdsajkasdsa;djaslhlsajljldhskajhd </div>-->
        <div class="ebook">
<!--            <ebooktitle :menushow="menushow"></ebooktitle>-->
            <div class="read-wrapper">
                <div id="read"  ></div>
                <v-touch v-on:swipeleft="swiperleft" v-on:swiperight="swiperright" class="wrapper">
                    <div class="mask">
                        <div class="left" @click="pervpage"></div>
                        <div class="center" @click="menushowfun"></div>
                        <div class="right" @click="nextpage"></div>
                    </div>
                </v-touch>
            </div>

            <ebookmenu
                    :defaultfontsize="defaultfontsize"
                    :fontsizelist="fontsizelist"
                    :menushow="menushow"
                    ref="menubar"
                    @setfontsizefun="setfontsizefun"
                    :themelist="themelist"
                    :defaulttheme="defaulttheme"
                    @settheme="settheme"
                    :bookavailable="bookavailable"
                    @onprogresschange="onprogresschange"
                    @jumpto="jumpto"
                    :navigation="navigation"

            ></ebookmenu>
            <div class="nonezhezhao" v-if="lodshow">
                <!--                <div class="jiazai"><img  src="static/img/zfw/timg11.gif" style="width: 10%"/></div>-->
                <div id="ajaxloader2" style="margin-top: 8rem">
                    <div class="outer"></div>
                    <div class="inner"></div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import  Epub from 'epubjs'
    import ebooktitle from "../components/ebooktitle"
    import ebookmenu from "../components/ebookmenu"
    const DOWNLOAD_URL='./static/5.epub'//'./static/book.epub'//'http://mediaapi.hebei.com.cn/book.epub'
    export default {
        name: "phone",
        components:{
            // ebooktitle,
            ebookmenu,
        },
        data() {
            return {
                lodshow:false,
                book:'',
                rendition:'',
                themes:'',
                menushow:false,
                istitleandmenu:false,
                fontsizelist:[
                    {fontSize:12},
                    {fontSize:14},
                    {fontSize:16},
                    {fontSize:18},
                    {fontSize:20},
                    {fontSize:22},
                    {fontSize:24},
                ],
                defaultfontsize:16,
                themelist:[
                    {
                        name:"1",
                        style:{
                            body:{
                                'color':'#000','background':'#fff'
                            },
                        }
                    },
                    // {
                    //     name:"2",
                    //     style:{
                    //         body:{
                    //             'color':'#000','background':'#ceeaba'
                    //         },
                    //     }
                    // },
                    // {
                    //     name:"3",
                    //     style:{
                    //         body:{
                    //             'color':'#fff','background':'#000'
                    //         },
                    //     }
                    // },
                    // {
                    //     name:"4",
                    //     style:{
                    //         body:{
                    //             'color':'#000','background':'rgb(241,236,226)'
                    //         },
                    //     }
                    // },

                ],
                defaulttheme:0,
                locations:'',
                //图书是否可用
                bookavailable:false,
                navigation:'',

            }
        },
        created() {

        },
        mounted() {
            this.lodshow=true
            this.getadress()
        },
        methods:{
            getadress(){
                this.axios.post("https://njswapp.hebei.com.cn/njsw/index.php/Mobile/Product/check_product",{channelId:this.getQueryString('channelId'),id:this.getQueryString('id')}).then( res => {
                    // console.log(JSON.stringify(res.data))
                    // alert(res.data.data.products[0].url)
                    this.showeup(res.data.data.products[0].url)

                })
            },
            getQueryString(name) {
                var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
                var reg_rewrite = new RegExp("(^|/)" + name + "/([^/]*)(/|$)", "i");
                var r = window.location.search.substr(1).match(reg);
                var q = window.location.pathname.substr(1).match(reg_rewrite);
                if(r != null){
                    return unescape(r[2]);
                }else if(q != null){
                    return unescape(q[2]);
                }else{
                    return null;
                }
            },
            swiperleft: function () {
                // console.log("左划")

                this.nextpage()
            },
            swiperright: function () {
                // console.log("右滑")
                this.pervpage()
            },

            //根据链接跳转指定位置
            jumpto(herf){
                this.rendition.display(herf);
                this.hidetitleandmenu()
            },
            hidetitleandmenu(){
                //隐藏标题栏和菜单栏

                this.menushow=false
                //隐藏弹出的设置栏
                this.$refs.menubar.hidesetfontsize()
                //隐藏目录
                this.$refs.menubar.hidecontent()
            },
            //进度条0-100
            onprogresschange(progress){
                const  percentage=progress/100
                const  location=percentage>0 ? this.locations.cfiFromPercentage(percentage) : 0
                this.rendition.display(location)
            },
            settheme(index){
                this.themes.select(this.themelist[index].name)
                this.defaulttheme=index
            },
            registertheme(){
                this.themelist.forEach(theme=>{
                    this.themes.register(theme.name,theme.style)
                })
            },
            setfontsizefun(fonsize){
                this.defaultfontsize=fonsize
                if(this.themes){
                    this.themes.fontSize(fonsize+'px')
                }
            },
            menushowfun(){
                this.menushow=!this.menushow
                if(!this.menushow){
                    this.$refs.menubar.hidesetfontsize()
                }

            },
            pervpage(){
                if(this.rendition){
                    this.rendition.prev()
                }
            },
            nextpage(){
                if(this.rendition){
                    this.rendition.next()
                }
            },
            showeup(url){

                this.book=new Epub(url)
                    const u = navigator.userAgent;
                    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                    if (isiOS) {
                        // this.$utils.msgshow('ios')
                        this.rendition=this.book.renderTo('read',{
                            width:window.innerWidth,
                            height:window.innerHeight,
                            textAalign: 'center',
                            method:'default'


                        })

                    } else {
                        this.rendition=this.book.renderTo('read',{
                            width:window.innerWidth,
                            height:window.innerHeight,
                            textAalign: 'center',
                            // method:'default'


                        })


                    }

                //通过rendition.display渲染电子书
                this.rendition.display()
                //获取themes对象
                this.themes=this.rendition.themes
                // console.log( this.themes)
                //设置默认字体
                this.setfontsizefun(this.defaultfontsize)
                this.registertheme()
                this.settheme(this.defaulttheme)
                //获取locations
                //通过Epubjs的钩子函数实现
                this.book.ready.then(()=>{
                    this.navigation=this.book.navigation
                    // console.log(this.navigation)
                    return this.book.locations.generate()
                }).then(result=>{
                    this.locations=this.book.locations;
                    this.bookavailable=true;
                    this.lodshow=false
                    // this.onprogresschange(50)
                    // console.log(result)
                })

            }
        },
    }
</script>

<style scoped lang="scss">
    /*html body{*/
    /*    padding: 0;*/
    /*    margin: 0;*/
    /*}*/
    @import '../assets/styles/global.scss';
    .ebook{
        position: relative;

        .nonezhezhao{
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            background: rgba(0,0,0,0.5);
            .jiazai{
                text-align: center;

                margin-top: 7rem;
            }
        }
        .read-wrapper{

            .mask{
                position: absolute;
                top:0;
                left:0;
                width: 100%;
                height: 100%;
                z-index: 100;
                display: flex;
            }
            .left{
                flex: 0 0 px2rem(100);
            }
            .center{
                flex:1;
            }
            .right{
                flex: 0 0 px2rem(100);
            }
        }

    }

</style>



// WEBPACK FOOTER //
// src/views/phone.vue